module.exports = __webpack_public_path__ + "img/bca.607df0ea.png";